module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"okayButton":"Okay","dismissButton":"Cancel","tooltip":{"closeModal":"Cancel"}},"de":{"okayDefault":"Okay","dismissDefault":"Abbrechen","tooltip":{"closeModal":"Abbrechen"}},"fr":{"okayButton":"Okay","dismissButton":"Annuler","tooltip":{"closeModal":"Annuler"}},"it":{"okayButton":"Ok","dismissButton":"Cancella","tooltip":{"closeModal":"Cancella"}}}')
  delete Component.options._Ctor
}
